/**
 * Appstle Subscription UX Fix – Resolves Inconsistent Selection Behaviour
 *
 * This script fixes a UX inconsistency in the Appstle subscription widget
 * where users could select a delivery interval without selecting the
 * "Subscribe and save" option — resulting in a state where subscription
 * can't be added to cart.'
 *
 * - Automatically selects "Subscribe and save" if a delivery interval is chosen
 * - Deselects interval options when "One Time Purchase" is selected
 * - Clears conflicting selections on page load
 * - Works generically without hardcoded selling plan IDs
 * - Debug logs available via ?td-appstle-debug=true
 *
 */

(function () {
  const debug = new URLSearchParams(window.location.search).get('td-appstle-debug') === 'true';
  const log = (...args) => debug && console.log('[Appstle Debug]', ...args);
  const state = {
    suppressAutoSelect: false,
    attached: false
  };

  function debounce(fn, delay) {
    let timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(fn, delay);
    };
  }

  function findSubscribeRadio() {
    const options = document.querySelectorAll('.appstle_subscription_wrapper_option');
    for (let option of options) {
      const label = option.querySelector('label.appstle_radio_label');
      const radio = option.querySelector('input[type="radio"][name="selling_plan"]');
      const isSubscribe = option.querySelector('.appstle_subscribe_save_text, .appstle-save-badge');
      if (label && radio && isSubscribe) return radio;
    }
    return null;
  }

  function attachLogic() {
    try {
      const intervalRadios = document.querySelectorAll('input[name="selling_plan_radio"]');
      const oneTimeRadio = document.querySelector('input[name="selling_plan"][value=""]');
      const subscribeRadio = findSubscribeRadio();

      if (!intervalRadios.length || !oneTimeRadio || !subscribeRadio) {
        log('Still waiting for required elements...');
        return;
      }

      if (state.attached) return; // prevent double-binding
      state.attached = true;

      log('Attaching Appstle UX logic');

      // On load: clear intervals if one-time is selected
      if (oneTimeRadio.checked) {
        intervalRadios.forEach(radio => {
          if (radio.checked) {
            log(`Clearing interval radio: ${radio.id}`);
            radio.checked = false;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      intervalRadios.forEach(radio => {
        radio.addEventListener('change', () => {
          if (state.suppressAutoSelect) {
            log('Suppressed auto-subscribe');
            return;
          }
          if (!subscribeRadio.checked) {
            log(`Interval selected: ${radio.id} → checking subscribe radio`);
            subscribeRadio.checked = true;
            subscribeRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });

      oneTimeRadio.addEventListener('change', () => {
        log('"One Time Purchase" selected — clearing intervals');
        state.suppressAutoSelect = true;
        intervalRadios.forEach(radio => {
          if (radio.checked) {
            radio.checked = false;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        requestAnimationFrame(() => {
          state.suppressAutoSelect = false;
          log('Suppression flag reset');
        });
      });

      log('Listeners attached');
    } catch (err) {
      console.error('[Appstle Debug] Error attaching logic:', err);
    }
  }

  const observer = new MutationObserver(
    debounce(() => {
      attachLogic();
    }, 200)
  );

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  log('MutationObserver started');
})();
